import { Download } from "@mui/icons-material";
import { Button, SxProps, Theme } from "@mui/material";
import React from "react";

import Excel from "exceljs";
import FileServer from "file-saver";
import moment from "moment";
import { useRoles } from "../../../../security/RolesProvider/RolesProvider";
import { STATIC_ROLES_NAMES } from "../../../../constants/enums";

interface ICSVExportPluginonPagination {
  filePrefixName: string;
  columns: ICSVColumnsFormat[];
  onExportButtonClick: () => Promise<ICSVDataFormat[]>;
  disabled?: boolean;
  label?: string;
  startIcon?: React.ReactNode;
  sx?:  SxProps<Theme>;
  showOnlyForSpecficRoles?: (keyof typeof STATIC_ROLES_NAMES)[];
}

export interface ICSVColumnsFormat {
  columnName: string;
  fieldName: string;
  width?: number;
  exportValue?: string | number | ((row: ICSVDataFormat) => string | number);
}

export interface ICSVDataFormat {
  [rowKey: string]: string | number;
}
  export const generateExcelSheet = async (content: ICSVDataFormat[], columns: ICSVColumnsFormat[], filePrefixName: string) => {
    const workbook = new Excel.Workbook();
    const sheet = workbook.addWorksheet("Sheet1", {
      views: [{ state: "frozen", ySplit: 1 }],
    });
    const generatedColumns = [];

    for (const column of columns) {
      generatedColumns.push({
        header: column.columnName,
        key: column.columnName,
        width: column.width || 10,
        // exportValue: column.exportValue,
      });
    }
    sheet.columns = generatedColumns;
    const rowsList: any = [];

    const reversedContent = [...content].reverse();
    for (const row of reversedContent) {
      const finalRow = [];
      let index = 0;
      for (const col of columns) {
        let data =
          typeof col.exportValue === "function"
            ? col.exportValue(row)
            : col.exportValue ?? row[col.fieldName];
        if (
          typeof data === "string" &&
          moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ", true).isValid()
        ) {
          data = moment(data).format("DD-MM-YYYY");
        }

        // if (col.onExportRender) {
        //   data = col.onExportRender(
        //     {
        //       column: {
        //         columnIndex: index,
        //         fieldName: col.fieldName,
        //         headerName: col.headerName,
        //         key: col.key,
        //         rowIndex: 0,
        //       },
        //       value: data,
        //     },
        //     row
        //   );
        // }

        finalRow.push(data);
        index = index + 1;
      }
      rowsList.push(finalRow);
    }
    const date = moment(new Date()).format("DD-MM-YYYY");
    sheet.addRows(rowsList);
    const buffer = await workbook.xlsx.writeBuffer();
    FileServer.saveAs(new Blob([buffer]), `${filePrefixName}-${date}.xlsx`);
  };


export const DataTableV2CSVExport: React.FC<ICSVExportPluginonPagination> = (
  props
) => {
  const {
    columns,
    filePrefixName,
    onExportButtonClick,
    disabled,
    label = "Download",
    startIcon = <Download />,
    sx,
    showOnlyForSpecficRoles: allowedRoles,
  } = props;
  const [loading, setLoading] = React.useState(false);
  const { roleName } = useRoles();
  const hasAccess = allowedRoles
    ? allowedRoles.includes(roleName.toUpperCase() as "ADMIN")
    : true;


  const handleExportClick = async () => {
    try {
      setLoading(true);
      const data = await onExportButtonClick();
      await generateExcelSheet(data, columns, filePrefixName);
      setLoading(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  if(!hasAccess){
    return null;
  }

  return (
    <>
      {/* <Tooltip title="Download Excel file(.csv)">
				<Button
					variant="text"
					sx={{ minWidth: "fit-content" }}
					onClick={handleExportClick}
					disabled={loading}
				>
					{loading ? (
						<>
							<CircularProgress
								size={18}
								sx={{ mr: 1 }}
							/>{" "}
							<Typography color="primary">Please wait...</Typography>
						</>
					) : (
						<Download color={"primary"} />
					)}
				</Button>
			</Tooltip> */}
      <Button
        variant="contained"
        color="primary"
        startIcon={startIcon}
        onClick={handleExportClick}
        disabled={disabled}
        sx={{ ml: 2,...sx }}
      >
        {label}
      </Button>
    </>
  );
};
